import { styled } from '@mui/material'
import { memo } from 'react'
import { ReactComponent as IconCollapse } from './collapse.svg'
import { useAtom } from 'jotai'
import { orderbookCollapsed } from './atoms'
import clsx from 'clsx'

const CollapseWrap = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 32px;
  background: rgba(22, 25, 30, 1);
  border: 1px solid rgba(42, 49, 57, 1);
  border-radius: 4px;
  position: absolute;
  top: 50%;
  right: 0;
  z-index: 10;
  transform: translate(50%, -50%);
  transition: all 0.2s ease;

  &:hover {
    cursor: pointer;
    color: rgba(160, 238, 9, 1);
    border-color: rgba(160, 238, 9, 1);
  }

  &.collapsed {
    svg {
      transform: rotate(180deg);
    }
  }

  ${(props) => props.theme.breakpoints.down('md')} {
    display: none;
  }
`

export const OrderbookCollapsed = memo(() => {
  const [collapsed, setCollapsed] = useAtom(orderbookCollapsed)
  return (
    <CollapseWrap
      className={clsx({ collapsed: collapsed })}
      onClick={() => setCollapsed(!collapsed)}
    >
      <IconCollapse />
    </CollapseWrap>
  )
})
